import { BagLogo } from "../components/Logo";

/** Terminal 404 page. Renders nothing privileged, performs NO redirect and makes NO auth or
 * membership request, so it never reveals whether the visitor has panel access. */
export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 text-center p-6 bg-[#F3F4F6]"
      data-testid="not-found-page">
      <BagLogo size={56} />
      <h1 className="font-display font-black text-4xl sm:text-5xl">404</h1>
      <p className="text-base text-slate-500">Stranica ne postoji.</p>
      <a href="/" className="text-brand-red font-semibold underline text-sm" data-testid="not-found-home">Nazad na Ponesi</a>
    </div>
  );
}
